import React, { Component } from 'react';
import {
    Route,
    Switch,
} from 'react-router-dom';
import { isEmpty,get } from 'lodash';
import asyncRoute from '../../helpers/hoc/asyncRoute';
import routes from '../../routes';

import { PrivateRoute } from '../../utils/route-auth';
import { PERMISSION } from '../../constants/permission';
import { isTenantAgency } from '../../selectors';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

const Ro = asyncRoute(() => import('./Ro'));
const AddRo = asyncRoute(() => import('./AddRo'));

class RO extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openAdUnitModal: false,
            openAdUnitGroupModal: false,
            openPMPModal: false,
            openMediationModal: false,
            isAgency:false
        };
    }

    componentWillMount() {
        let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
        if (isEmpty(isAuthenticated)) {
            const { history } = this.props;
            history.push(routes.preSignIn);
        }

        let isAgncy = isTenantAgency(this.props.tenantId);
        this.setState({isAgency:isAgncy});
    }

    render() {
        const { match } = this.props;
        const { isAgency } = this.state;

        return (
            <div>
                <Switch>
                    <Route exact path={`${match.path}`} render={() =>
                        <Ro match={match} />
                    }
                    />
                    {
                        !isAgency && 

                        <PrivateRoute path={`${match.path}/${routes.ro.addRo}`} component={AddRo}
                        permissions={[PERMISSION.RO.RO.ADD]}
                        defaultRoute={'ro'} />
                    }

                    {
                        !isAgency && 

                        <PrivateRoute path={`${match.path}/${routes.ro.editRo}/:id`} component={AddRo}
                        permissions={[PERMISSION.RO.RO.EDIT]}
                        defaultRoute={'ro'} />
                    }
                  
                </Switch>

            </div>
        );
    }
}

export default withRouter(connect(
    (state) => ({
      tenantId: get(state, 'app.preSignInState.tenantId', ''),
      userId: get(state, 'app.preSignInData.userId', ''),
      authToken: get(state, 'app.signInData.authToken', ''),
    })
  )(RO));
